import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ContractsListPage from './pages/ContractsListPage';
import ContractItemsPage from './pages/ContractItemsPage';
import VirtualWarehousePage from './pages/VirtualWarehousePage';

const ContractRoutes = () => {
  return (
    <Routes>
      <Route path="management" element={<ContractsListPage />} />
      <Route path="management/:contractId/items" element={<ContractItemsPage />} />
      <Route path="virtual-warehouse" element={<VirtualWarehousePage />} />
    </Routes>
  );
};

export default ContractRoutes;
